import { render, staticRenderFns } from "./PickUpCard.vue?vue&type=template&id=4d43f1ff&scoped=true&"
import script from "./PickUpCard.vue?vue&type=script&lang=js&"
export * from "./PickUpCard.vue?vue&type=script&lang=js&"
import style0 from "./PickUpCard.vue?vue&type=style&index=0&id=4d43f1ff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d43f1ff",
  null
  
)

export default component.exports